import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/worried-girl.svg'


const _hoisted_1 = {
  id: "modalRfbError",
  class: "modal fade",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "modalRfbMessageError",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog text-start" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-footer border-top-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"modal-header\" data-v-105e3214><h1 id=\"modalRfbMessageError\" class=\"modal-title fs-5 color--danger\" data-v-105e3214> Ops, algo deu errado </h1><button class=\"btn-close\" type=\"button\" data-bs-dismiss=\"modal\" aria-label=\"Fechar\" data-v-105e3214></button></div><div class=\"modal-body\" data-v-105e3214><div class=\"d-flex justify-content-center\" data-v-105e3214><img class=\"image\" style=\"height:186px;\" src=\"" + _imports_0 + "\" alt=\"Menina confusa, erro de consulta RFB\" data-v-105e3214></div><div data-v-105e3214><p class=\"fw-600\" data-v-105e3214> Algo deu errado ao consultar seu Pedido/<br data-v-105e3214>Voucher. </p><p data-v-105e3214> Por favor, <span class=\"fw-600\" data-v-105e3214>entre em contato com o fornecedor.</span></p><p data-v-105e3214>Obrigado por sua compreensão!</p></div></div>", 2)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn-fechar btn modal-footer_btn-process btn-primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.modalClose && _ctx.modalClose(...args)))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("span", null, "Fechar", -1)
          ]))
        ])
      ])
    ])
  ]))
}